var _rect, _rect2, _path, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSliderBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 496,
    viewBox: "0 0 1440 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_165_12429",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 496
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 496,
    fill: "#140230"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_165_12429)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.0000305176,
    width: 1440,
    height: 496,
    fill: "#140230"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter0_f_165_12429)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M753.398 267.422C652.402 109.788 442.74 63.874 285.106 164.871L265.421 177.483C107.787 278.479 61.874 488.141 162.871 645.775V645.775C263.867 803.409 473.529 849.323 631.163 748.326L650.848 735.714C808.482 634.717 854.395 425.056 753.398 267.422V267.422Z",
    fill: "url(#paint0_radial_165_12429)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter1_f_165_12429)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 801.611,
    height: 800.679,
    rx: 400.34,
    transform: "matrix(-0.938454 0.345405 0.345405 0.938454 1205.9 4)",
    fill: "#9450FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_165_12429",
    x: -101.52,
    y: -99.5197,
    width: 1119.31,
    height: 1112.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 105.395,
    result: "effect1_foregroundBlur_165_12429"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_165_12429",
    x: 340.14,
    y: -109.4,
    width: 1255.81,
    height: 1255.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 113.536,
    result: "effect1_foregroundBlur_165_12429"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_165_12429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(458.135 456.598) rotate(57.3522) scale(338.98 1115.08)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2400FF",
    stopOpacity: 0.37
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderBg);
export default __webpack_public_path__ + "static/media/slider_bg.6450a62eb1bff38034d1e2d50bdc6cae.svg";
export { ForwardRef as ReactComponent };